import { Routes, Route } from "react-router-dom";
import FindUrl from "./FindUrl";

function App() {
  return (
    <Routes>
      <Route path="/" element={<FindUrl />} />
      <Route path="/:shortcut" element={<FindUrl />} />
    </Routes>
  );
}

export default App;
